<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
            <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">รายงานขายรอบที่ {{ roundList.round_count }}</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
            </v-row>

            <div class="mt-1">

                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>พิมพ์ใบสรุปยอดขาย</div>
                                        </div>
                                    </v-card>
                                </div>
                                <div class="mt-4">
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                            <div class="mt-6 mb-3">
                                                <v-btn v-if="data_store.receipt_size == 1" type="" height="40"
                                                    @click="link('/arin/pos/posinvoicereceiptfull?id=' + $route.params.id + '&type=0', 'bank')"
                                                    class="white--text grad-success-arin-bg btn_add_data"
                                                    style="font-size: 18px; border-radius: 10px;"><v-icon class="mr-2" right
                                                        dark>
                                                        mdi-printer
                                                    </v-icon> พิมพ์ใบสรุปยอดขายทั้งหมด</v-btn>
                                                
                                                <v-btn v-else type="" height="40"
                                                    @click="link('/arin/pos/posinvoicereceipt58mm?id=' + $route.params.id + '&type=0', 'bank')"
                                                    class="white--text grad-success-arin-bg btn_add_data"
                                                    style="font-size: 18px; border-radius: 10px;"><v-icon class="mr-2" right
                                                        dark>
                                                        mdi-printer
                                                    </v-icon> พิมพ์ใบสรุปยอดขายทั้งหมด</v-btn>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                            <div class="mt-6 mb-3">
                                                <v-btn type="" height="40" @click="open_detail_bill_group"
                                                    class="white--text grad-success-arin-bg btn_add_data"
                                                    style="font-size: 18px; border-radius: 10px;"> <v-icon class="mr-2"
                                                        right dark>
                                                        mdi-printer
                                                    </v-icon>พิมพ์ใบสรุปยอดขายเฉพาะรายการ</v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>

                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>


                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>ยอดขาย</div>
                                        </div>
                                    </v-card>
                                </div>
                                <div class="my-4">
                                    <v-row>
                                        <v-col cols="12" class="title_page_space" style="border-right: 1px solid #D4D4D4;"
                                            md="5" lg="5" xl="5">
                                            <div>
                                                <div class="font-38 bold color_brown">{{ roundList.count_order }}</div>
                                                <div class="text-grey font-18 bold">จำนวนออเดอร์</div>
                                            </div>
                                            <div>
                                                <div class="font-38 bold color_green">{{ formatPrice(roundList.total_amount)
                                                }} บาท</div>
                                                <div class="text-grey font-18 bold">ยอดขาย</div>
                                            </div>
                                        </v-col>

                                        <v-col cols="12" class="title_page_space" md="7" lg="7" xl="7">
                                            <div>
                                                <label class="bold color_brown">ยอดเงินที่ได้รับ</label>
                                                <div class="mt-2 font-24 bold">{{ formatPrice(roundList.total_cash) }}</div>
                                                <div class="text-grey font-16 bold">ยอดเงินสด</div>
                                            </div>
                                            <div class="pt-8">
                                                <div class="mt-2 font-24 bold">{{ formatPrice(roundList.total_payment) }}
                                                </div>
                                                <div class="text-grey font-16 bold">ยอดเงินโอน</div>
                                            </div>
                                            <div class="pt-8">
                                                <div class="mt-2 font-24 bold">{{ formatPrice(roundList.total_qr) }}
                                                </div>
                                                <div class="text-grey font-16 bold">ยอดเงิน QR CODE</div>
                                            </div>
                                            <div class="pt-8">
                                                <div class="mt-2 font-24 bold">{{ formatPrice(roundList.total_credit) }}
                                                </div>
                                                <div class="text-grey font-16 bold">ยอดบัตรเครดิต</div>
                                            </div>
                                            <div class="pt-8">
                                                <div class="mt-2 font-24 bold">{{ formatPrice(roundList.total_etc) }}</div>
                                                <div class="text-grey font-16 bold">ยอดอื่น ๆ</div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>ยอดขายจากบัตรเครดิตแต่ละประเภท</div>
                                        </div>
                                    </v-card>
                                </div>
                                <div class="my-4">
                                    <v-row>
                                        <v-col cols="12" class="title_page_space">
                                            <div v-for="(credit_card, index) in credit_card" :key="index">
                                                <div class="mt-2 font-24 bold">{{ formatPrice(credit_card.credit_pay) }}
                                                </div>
                                                <div class="text-grey font-16 bold">{{ credit_card.card_name_th }}</div>
                                            </div>

                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>การตรวจสอบยอดขายประจำรอบ</div>
                                        </div>
                                    </v-card>
                                </div>
                                <div class="my-4">
                                    <v-row>
                                        <v-col cols="12" class="title_page_space" style="border-right: 1px solid #D4D4D4;"
                                            md="5" lg="5" xl="5">
                                            <div>
                                                <div class=""
                                                    :class="(roundList.diff_total_amount >= 0) ? 'font-32 bold color_green' : 'font-32 bold color_red'">
                                                    {{ formatPrice(roundList.diff_total_amount) }}</div>
                                                <div class="text-grey font-16 bold">เงินส่วนต่าง</div>
                                            </div>
                                            <div>
                                                <div class="text-grey font-16 bold">ผู้ปิดรอบ : {{ (roundList.user_close) ?
                                                    roundList.user_close : '-' }}
                                                </div>
                                            </div>
                                        </v-col>

                                        <v-col cols="12" class="title_page_space" md="7" lg="7" xl="7">
                                            <div>
                                                <label class="bold color_brown">ยอดเงินส่วนต่าง</label>
                                                <div
                                                    :class="(roundList.diff_total_cash >= 0) ? 'mt-2 font-24 bold color_green' : 'mt-2 font-24 bold color_red'">
                                                    {{
                                                        formatPrice(roundList.diff_total_cash) }}</div>
                                                <div class="text-grey font-16 bold">ส่วนต่างเงินสด</div>
                                            </div>
                                            <div class="pt-8">
                                                <div
                                                    :class="(roundList.diff_total_payment >= 0) ? 'mt-2 font-24 bold color_green' : 'mt-2 font-24 bold color_red'">
                                                    {{
                                                        formatPrice(roundList.diff_total_payment) }}</div>
                                                <div class="text-grey font-16 bold">ส่วนต่างเงินโอน</div>
                                            </div>
                                            <div class="pt-8">
                                                <div
                                                    :class="(roundList.diff_total_qr >= 0) ? 'mt-2 font-24 bold color_green' : 'mt-2 font-24 bold color_red'">
                                                    {{
                                                        formatPrice(roundList.diff_total_qr) }}</div>
                                                <div class="text-grey font-16 bold">ส่วนต่างเงิน QR CODE</div>
                                            </div>
                                            <div class="pt-8">
                                                <div
                                                    :class="(roundList.diff_total_credit >= 0) ? 'mt-2 font-24 bold color_green' : 'mt-2 font-24 bold color_red'">
                                                    {{
                                                        formatPrice(roundList.diff_total_credit) }}</div>
                                                <div class="text-grey font-16 bold">ส่วนต่างบัตรเครดิต</div>
                                            </div>
                                            <div class="pt-8">
                                                <div
                                                    :class="(roundList.diff_total_etc >= 0) ? 'mt-2 font-24 bold color_green' : 'mt-2 font-24 bold color_red'">
                                                    {{
                                                        formatPrice(roundList.diff_total_etc) }}</div>
                                                <div class="text-grey font-16 bold">ส่วนต่างอื่น ๆ</div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>

                            </v-card>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <!-- <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>มูลค่าใบเสร็จมี VAT และไม่มี VAT</div>
                                        </div>
                                    </v-card>
                                </div>
                                <div class="my-4">
                                    <v-row>
                                        <v-col cols="12" class="title_page_space" style="border-right: 1px solid #D4D4D4;"
                                            md="6" lg="6" xl="6">
                                            <div>
                                                <div class="font-38 bold color_brown">{{ roundList.count_order }}</div>
                                                <div class="text-grey font-18 bold">จำนวนใบเสร็จคิด VAT</div>
                                            </div>
                                            <div>
                                                <div class=""
                                                    :class="(roundList.diff_total_amount >= 0) ? 'font-32 bold color_green' : 'font-32 bold color_red'">
                                                    {{ formatPrice(roundList.diff_total_amount) }} บาท</div>
                                                <div class="text-grey font-16 bold">มูลค่ารวมใบเสร็จคิด VAT</div>
                                            </div>
                                        </v-col>

                                        <v-col cols="12" class="title_page_space" md="6" lg="6" xl="6">
                                            <div>
                                                <div class="font-38 bold color_brown">{{ roundList.count_order }}</div>
                                                <div class="text-grey font-18 bold">จำนวนใบเสร็จไม่คิด VAT</div>
                                            </div>
                                            <div>
                                                <div class=""
                                                    :class="(roundList.diff_total_amount >= 0) ? 'font-32 bold color_green' : 'font-32 bold color_red'">
                                                    {{ formatPrice(roundList.diff_total_amount) }} บาท</div>
                                                <div class="text-grey font-16 bold">มูลค่ารวมใบเสร็จไม่คิด VAT</div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>

                            </v-card>
                        </div>
                    </v-col> -->
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>สินค้าขายดี 10 อันดับ</div>
                                        </div>
                                    </v-card>
                                </div>

                                <div class="my-4">
                                    <v-row>
                                        <v-col cols="12">
                                            <template>
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center font-16">
                                                                    อันดับ
                                                                </th>
                                                                <th class="text-left font-16">
                                                                    ชื่อสินค้า
                                                                </th>
                                                                <th class="text-center font-16">
                                                                    จำนวน
                                                                </th>
                                                                <th class="text-center font-16">
                                                                    หน่วยนนับ
                                                                </th>
                                                                <th class="text-center font-16">
                                                                    ยอดขาย
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in product_list" :key="item.name">
                                                                <td class="text-center font-16">{{ item.product_code }}</td>
                                                                <td class="font-16">{{ item.product_name }}</td>
                                                                <td class="text-center font-16">{{ item.count_sale }}</td>
                                                                <td class="text-center font-16">{{ (item.unit_name) ?
                                                                    item.unit_name : '-' }}</td>
                                                                <td class="text-center font-16">{{ item.total_sale }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <div class="ma-5">
                            <v-card elevation="4" class="pa-3 card_relative" style="height:100%;">
                                <div class="tag_header_profile d-flex">
                                    <div class="grad-dark-brown-arin-bg pa-3 rounded-pill"
                                        style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                        <div class="logo_timeline mx-auto my-auto">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <v-card elevation="3" class="card_title ml-n5">
                                        <div class="arin-text-color d-flex align-center py-1 pl-8 pr-5 pt-3">
                                            <div>บริการขายดี 10 อันดับ</div>
                                        </div>
                                    </v-card>
                                </div>

                                <div class="my-4">
                                    <v-row>
                                        <v-col cols="12">
                                            <template>
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center font-16">
                                                                    อันดับ
                                                                </th>
                                                                <th class="text-left font-16">
                                                                    ชื่อบริการ
                                                                </th>
                                                                <th class="text-center font-16">
                                                                    จำนวน
                                                                </th>
                                                                <th class="text-center font-16">
                                                                    ยอดขาย
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in data_list" :key="item.name">
                                                                <td class="text-center font-16">{{ item.no }}</td>
                                                                <td class="font-16">{{ item.product_name }}</td>
                                                                <td class="text-center font-16">{{ item.qty }}</td>
                                                                <td class="text-center font-16">{{ item.sum_price }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>

            </div>

            <!-- รายละเอียด -->
            <v-dialog v-model="show_detail_bill_group" persistent max-width="650px">
                <v-card class="input-radius">
                    <v-card-title class="d-flex  pt-2">
                        <v-row>
                            <v-col cols="7 pt-5 pb-1 ">
                                <div class="font-20 bold">
                                    เลือกใบเสร็จที่ต้องการรวมยอด
                                </div>
                            </v-col>

                            <v-col cols="5 text-right pt-5 pb-1 ">
                                <v-btn icon class="ma-1" @click="close_model_all()">
                                    <v-icon color="grey">mdi-close</v-icon>
                                </v-btn>
                            </v-col>


                            <v-row class="mx-3 mt-2 mb-3 pb-2 pl-2 border-bill-green input-radius">
                                <v-col cols="12 pt-4">
                                    <div class="color_green font-16 bold">
                                        รวมยอดขาย {{ formatPrice(sum_all) }} บาท
                                    </div>
                                </v-col>
                                <v-col>
                                    <div class="font-16 bold">{{ formatPrice(sum_cash) }}</div>
                                    <div class="font-12 " style="line-height: 1rem;">ยอดเงินสด</div>
                                </v-col>
                                <v-col>
                                    <div class="font-16 bold">{{ formatPrice(sum_payment) }}</div>
                                    <div class="font-12 " style="line-height: 1rem;">ยอดเงินโอน</div>
                                </v-col>
                                <v-col>
                                    <div class="font-16 bold">{{ formatPrice(sum_qr) }}</div>
                                    <div class="font-12 " style="line-height: 1rem;">ยอดเงิน QR CODE</div>
                                </v-col>
                                <v-col>
                                    <div class="font-16 bold">{{ formatPrice(sum_credit) }}</div>
                                    <div class="font-12 " style="line-height: 1rem;">ยอดบัตรเครดิต</div>
                                </v-col>
                                <v-col>
                                    <div class="font-16 bold">{{ formatPrice(sum_other) }}</div>
                                    <div class="font-12 " style="line-height: 1rem;">ยอดอื่น ๆ</div>
                                </v-col>

                            </v-row>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-container class="pa-7 border-bill input-radius">
                            <v-row>
                                <v-col cols="12">
                                    <template>
                                        <v-simple-table fixed-header height="350px">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" width="50">
                                                            <v-container fluid class="pa-0">
                                                                <v-checkbox v-model="checkbox_all"
                                                                    class="pa-0"></v-checkbox>
                                                            </v-container>
                                                        </th>
                                                        <th class="text-left">
                                                            เลขที่ใบเสร็จ
                                                        </th>
                                                        <th class="text-left">
                                                            ยอดขาย
                                                        </th>
                                                        <th class="text-left">
                                                            การชำระเงิน
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in dataList" :key="index">
                                                        <td>
                                                            <v-container fluid class="pa-0">
                                                                <v-checkbox v-model="sum_data" :value="item.id"
                                                                    @change="sumTotal(item.id,)" class="pa-0"></v-checkbox>
                                                            </v-container>
                                                        </td>
                                                        <td>{{ item.invoice_code }}</td>
                                                        <td>{{ item.total }}</td>
                                                        <td>

                                                            <span
                                                                v-if="item.pay_type.find(o => o == 0) != null">ยังไม่ได้ชำระ</span>
                                                            <span
                                                                v-if="item.pay_type.find(o => o == 1) != null">เงินสด</span>
                                                            <span
                                                                v-if="item.pay_type.find(o => o == 2) != null">เงินโอน</span>
                                                            <span
                                                                v-if="item.pay_type.find(o => o == 3) != null">บัตรเครดิต</span>
                                                            <span
                                                                v-if="item.pay_type.find(o => o == 4) != null">อื่นๆ</span>
                                                            <span
                                                                v-if="item.pay_type.find(o => o == 5) != null">Qrcode</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn type="submit" @click="printFromList" height="45" width="200" class="white--text grad-success-arin-bg mobile_btn"
                            style="font-size: 18px; border-radius: 10px;">พิมพ์ใบสรุปยอดขาย</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </div>
    </div>
</template>
  
<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_sale_report",
    data() {
        return {
            loading_page: true,
            dialog_cancel_order: false,
            show_detail_bill_group: false,
            checkbox_all: false,
            checkbox_select: false,
            search: '',
            data_store: {},
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            roundList: {},
            credit_card: [],
            product_list: [],
            dataList: [],
            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'การขาย',
                    disabled: false,
                },
                {
                    text: 'รายงานขาย',
                    disabled: false,
                },
            ],
            sum_data: [],
            sum_all:0,
            sum_cash: 0,
            sum_payment: 0,
            sum_qr: 0,
            sum_credit: 0,
            sum_other: 0,

        }
    }, methods: {
        printFromList(){
            window.localStorage.setItem("sum_data", JSON.stringify(this.sum_data));
            if(this.data_store.receipt_size == 1){
                this.link('/arin/pos/posinvoicereceiptfull?id=' + this.$route.params.id + '&type=1', 'bank');
            }else{
                this.link('/arin/pos/posinvoicereceipt58mm?id=' + this.$route.params.id + '&type=1', 'bank');
            }
        },
        link(link) {
            window.location.href = link;
        },
        formatPrice(number) {
            return formatPrice(number)
        },
        open_detail_bill_group() {
            window.localStorage.removeItem('sum_data');
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let id = this.$route.params.id;
            HTTP_ARIN.get(`/pos/report/get/list/for/print/${id}`, config).then(async (res) => {
                if (res.data.successful === true) {
                    this.dataList = await res.data.data
                    this.show_detail_bill_group = true
                }
            })

        },
        getShow_api() {
            let store_id = this.$store.state.store_arin.user_data.store_id;
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
                if (res.data.successful === true) {
                    this.data_store = res.data.storeDetail
                }
            })
        },
        sumTotal(id) {
            let check_id = this.sum_data.find(o => o == id);
            if (check_id > 0) {
                let data = this.dataList.find(o => o.id == id)
                if (data.pay_type.find(o => o == 1) != null) {
                    this.sum_cash += parseFloat(data.total)
                }
                if (data.pay_type.find(o => o == 2) != null) {
                    this.sum_payment += parseFloat(data.total)
                }
                if (data.pay_type.find(o => o == 3) != null) {
                    this.sum_credit += parseFloat(data.total)
                }
                if (data.pay_type.find(o => o == 4) != null) {
                    this.sum_other += parseFloat(data.total)
                }
                if (data.pay_type.find(o => o == 5) != null) {
                    this.sum_qr += parseFloat(data.total)
                }
                this.sum_all += parseFloat(data.total)
            } else {
                let data = this.dataList.find(o => o.id == id)
                if (data.pay_type.find(o => o == 1) != null) {
                    this.sum_cash -= parseFloat(data.total)
                }
                if (data.pay_type.find(o => o == 2) != null) {
                    this.sum_payment -= parseFloat(data.total)
                }
                if (data.pay_type.find(o => o == 3) != null) {
                    this.sum_credit -= parseFloat(data.total)
                }
                if (data.pay_type.find(o => o == 4) != null) {
                    this.sum_other -= parseFloat(data.total)
                }
                if (data.pay_type.find(o => o == 5) != null) {
                    this.sum_qr -= parseFloat(data.total)
                }
                this.sum_all -= parseFloat(data.total)
            }

        },
        close_model_all() {
            this.show_detail_bill_group = false
        },
        async storeReportRound() {
            this.loading_page = true
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let id = this.$route.params.id;
            HTTP_ARIN.get(`/pos/report/round/${id}`, config).then((res) => {
                if (res.data.successful === true) {
                    this.roundList = res.data.data.round_list
                    this.credit_card = res.data.data.credit_card
                    this.product_list = res.data.data.product_list
                    this.loading_page = false
                }
            })
        },

    },
    mounted() {
        this.storeReportRound()
    },
    watch: {
    }
}
</script>
  
<style scoped>
.btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #88B358 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
}

.title_page_space {
    display: flex;
    align-items: center;
    justify-content: space-around;

}

.color_brown {
    color: #84611F;
}

.color_green {
    color: #88B358;
}

.color_red {
    color: #F28080;
}

.card_relative {
    position: relative;
    border-radius: 15px;
}

.profile_detail {
    display: grid;
    grid-template-columns: 30% 70%;
}

.header_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.logo_timeline {
    width: 25px;
    height: 25px;
}

.logo_timeline>img {
    max-width: 25px;
}

.tag_header_profile {
    position: absolute;
    top: -30px;
    left: -15px;
}

.arin-text-color {
    color: #84611F;
    font-weight: bold;
    font-size: 16px;
}

.arin-text-color-two {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}

.card_title {
    margin-top: 1px;
    margin-bottom: 1px;
    border-radius: 10px;
    border: 1px solid #D6BFAF;
}

.preview {
    border-radius: 10px;
}

.employee_box {
    border-radius: 10px;
    border: 1px solid #D6BFAF;
    width: auto;
}

.sub_title {
    font-size: 16px;
}

.image_title {
    font-weight: 500;
    font-size: 16px;
}

.picture_details {
    display: grid;
    grid-template-columns: 40% 60%;
}

.mobile_btn {
    width: 40%;
}

.grid_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.grid_four_ck {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
}

.text_title {
    color: #909090;
    font-weight: bold;
    font-size: 16px;
}

.text_detail {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}

.text_unit {
    font-size: 20px;
}

.v-application {
    padding: 13px !important;
}

.logo_timeline {
    padding: 0px;
}
.font-12{
    font-size: 12px;
}

.border-bill {
    border: 1px solid #F0F0F0;
}

.border-bill-green {
    border: 1px solid #88B358;
}

.border-style-b {
    /* border-style: dotted;
    border-color: #ADADAD; */
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px dotted #ADADAD;
}

.title_page_right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.title_page_center {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
  